<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <div class="pa-3">
          <v-row>
            <v-col cols="12">
              <div class="d-flex justify-space-between align-center">
                <h3>ดูรายละเอียดล๊อตออก</h3>
                <v-btn class="grad-primary-bg white--text" height="50" width="20%" @click="$router.push('/alllot')">
                  ย้อนกลับ
                </v-btn>
              </div>
              <div class="grid_lot_detail_out_list mt-2">

                <div class="grid_lot_detail_out_list">
                  <div>รหัสล๊อตออก</div>
                  <div>{{ lot_detail.lot_code }}</div>
                  <div>วันที่</div>
                  <div>{{ lot_detail.dateTime }}</div>
                </div>

                <div class="grid_lot_detail_out_list">
                  <div>รหัสใบสั่งซื้ออ้างอิง</div>
                  <div>{{ lot_detail.refer }}</div>
                  <div>ผู้ตรวจสอบของออก</div>
                  <div>{{ lot_detail.user_name }}</div>
                </div>
              </div>
              <div class="mt-2">
                <v-simple-table>
                  <thead>
                  <tr>
                    <th rowspan="2" class="text-center border_header_lot_detail_out_list">
                      รายการ
                    </th>
                    <th rowspan="2" class="text-center border_header_lot_detail_out_list">
                      ราคาต้นทุน
                    </th>
                    <th rowspan="2" class="text-center border_header_lot_detail_out_list">
                      ยอดเบิก
                    </th>
                    <th rowspan="2" class="text-center border_header_lot_detail_out_list">
                      ใช้
                    </th>
                    <th rowspan="2" class="text-center border_header_lot_detail_out_list">
                      ทิ้ง
                    </th>
                    <th colspan="2" class="text-center border_header_lot_detail_out_list">
                      มูลค่ารวม
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center border_header_lot_detail_out_list">
                      ใช้
                    </th>
                    <th class="text-center border_header_lot_detail_out_list">
                      ทิ้ง
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(detail,index) in data" :key="index">
                    <td class="text-center border_header_lot_detail_out_list">{{ detail.name }}</td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ detail.price }}
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      <div @click="get_log_detail(detail.id, detail.name)">{{ currencyFormat(detail.quantity) }}</div>
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(detail.use_qty) }}
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(detail.lose_qty) }}
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(detail.use_qty * detail.price) }}
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(detail.lose_qty * detail.price) }}
                    </td>
                  </tr>

                  <tr>
                    <td colspan="5" class="text-center border_header_lot_detail_out_list">

                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(data.reduce((sum,number) => { return sum + parseFloat(number.use_qty * number.price) }, 0)) }}
                    </td>
                    <td class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(data.reduce((sum,number) => { return sum + parseFloat(number.lose_qty * number.price) }, 0)) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="text-center border_header_lot_detail_out_list">
                      รวม
                    </td>
                    <td colspan="2" class="text-center border_header_lot_detail_out_list">
                      {{ currencyFormat(data.reduce((sum,number) => { return sum + parseFloat(number.use_qty * number.price) }, 0) + data.reduce((sum,number) => { return sum + parseFloat(number.lose_qty * number.price) }, 0)) }}
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="open_show_withdrawn" persistent max-width="600px">
        <div v-if="loading_detail_page === true">
          <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <v-card v-if="loading_detail_page === false">
          <v-card-title>
            ประวัติการเบิก {{ item_product }}
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-simple-table>
                    <thead>
                    <tr>
                      <th class="text-center border_header_add_lotout_list">
                        เวลาเบิก
                      </th>
                      <th class="text-center border_header_add_lotout_list">
                        จำนวน
                      </th>
                      <th class="text-center border_header_add_lotout_list">
                        หน่วยนับ
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(top_draw_list_details, index) in log_history" :key="index">
                        <td class="text-center border_header_add_lotout_list">
                          {{ top_draw_list_details.time }}
                        </td>
                        <td class="text-center border_header_add_lotout_list">
                          {{ currencyFormat(top_draw_list_details.quantity) }}
                        </td>
                        <td class="text-center border_header_add_lotout_list">
                          {{ top_draw_list_details.unit_name }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" type="button" height="50" @click="open_show_withdrawn = false">
              ยกเลิก
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import inoutstockall from '@/api/stock/stocklist/inoutstockall.js'
import {
  currencyFormat
} from '@/helper/numberformat.js'
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: true,
      loading_detail_page: false,
      open_show_withdrawn: false,
      item_product: null,
      lot_detail: null,
      data: [],
      log_history: [],
    }
  },
  methods: {
    currencyFormat,
    async get_log_detail(id, name) {
      this.item_product = name
      this.open_show_withdrawn = true
      let result_filter = this.data.find((data) => data.id === id)
      this.log_history = result_filter.history
    },
    async lotOutDetail() {
      this.loading_page = true
      inoutstockall.lotOutDetail(this.$store.state.lotDetailOutId,1).then((response) => {
        if (response.data.successful === true) {
          this.lot_detail = response.data.lot
          this.data = response.data.lot_detail
          this.loading_page = false
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    }
  },
  mounted() {
    this.lotOutDetail()
  },
}
</script>

<style scoped>
.grid_lot_detail_out_list {
  display: grid;
  grid-template-columns: auto auto;
}

.border_header_lot_detail_out_list {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>
